import { Injectable } from '@angular/core';
import { CurrencyDto } from '@osos/shared/api';
import { CurrencyPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable()
export class CurrencyParserV1Service extends ParserBase<
  CurrencyDto,
  CurrencyPresenterModel
> {
  constructor() {
    super(CurrencyDto, CurrencyPresenterModel, 1);
  }

  getPresenterModel(model: Partial<CurrencyDto>): CurrencyPresenterModel {
    return {
      id: model.id,
      decimalPlaces: model.decimalPlaces,
      displaySuffix: model.displaySuffix,
      name: model.name,
    };
  }
  getDataModel(presenter: CurrencyPresenterModel): CurrencyDto {
    return {
      id: presenter.id,
      decimalPlaces: presenter.decimalPlaces,
      displaySuffix: presenter.displaySuffix,
      name: presenter.name,
    };
  }
}
